import { CATEGORY_LINKS } from "../../../../content/index.content";
import proAiExtension from "./ProductResearchTools/proAiExtension";
import productDatabase from "./ProductResearchTools/productDatabase";
import quickView from "./ProductResearchTools/quickView";
import dropshipping from "./ProductResearchTools/dropshipping";
import keywordSearch from "./KeywordsAndProductListingTools/keywordSearch";
import productKeywordsLookup from "./KeywordsAndProductListingTools/productKeywordsLookup";
import keywordToolsForAmazon from "./KeywordsAndProductListingTools/keywordToolsForAmazon";
import feesCalculatorForAmazonFBA from "./FreeTools/feesCalculatorForAmazonFBA";
import stockStats from "./FreeTools/stockStats";
import salesEstimator from "./FreeTools/salesEstimator";
import individualProductResearch from "./ReadyMadeSolutions/individualProductResearch";
import seoListingOptimization from "./ReadyMadeSolutions/seoListingOptimization";
import aiListingBuilder from "./KeywordsAndProductListingTools/aiListingBuilder";
// import tikTokShopTrendsResearch from "./ReadyMadeSolutions/tikTokShopTrendsResearch";
import aiReviewAnalyzer from "./KeywordsAndProductListingTools/aiReviewAnalyzer";

export const updateLinksSite = ({ language, isSavedUser }) => {
  const generateCategory = (category, links, icon) => ({
    category: CATEGORY_LINKS[category],
    links: links.map((link) => link({ language, isSavedUser })),
    icon,
  });
  return [
    generateCategory("PRODUCT_RESEARCH_TOOLS", [
      proAiExtension,
      productDatabase,
      quickView,
      dropshipping,
    ]),
    generateCategory("KEYWORDS_AND_LISTING_TOOLS", [
      keywordSearch,
      productKeywordsLookup,
      keywordToolsForAmazon,
      aiListingBuilder,
      aiReviewAnalyzer,
    ]),
    generateCategory("FREE_TOOLS", [
      feesCalculatorForAmazonFBA,
      stockStats,
      salesEstimator,
    ]),
    generateCategory("READY_MADE_SOLUTIONS", [
      individualProductResearch,
      seoListingOptimization,
    ]),
  ];
};

// export const updateLinksPartners = ({ language, isSavedUser }) => {
//   const generateCategory = (links) => ({
//     links: links.map((link) => link({ language, isSavedUser })),
//   });
//   return [
//     generateCategory([
//       manageYourReviewsUsing,
//       shippingFromChinaToAmazonFBAUsing,
//     ]),
//     generateCategory([sellAndShipOnShopify, collectReviewsAndBoost]),
//     generateCategory([getFastFundingUsing, dropshipAnywhere]),
//   ];
// };
